/* eslint-disable @typescript-eslint/no-explicit-any */
export class FilterItem {
  active?: boolean;
  data?: any;
  description?: string;
  filters_applied_message?: string;
  help_link?: string;
  icon?: string;
  id: string;
  min_date?: Date;
  max_date?: Date;
  name: string;
  options: IFilterOption[];
  options_selected: number;
  type: FilterTypes;
  value?: any;
}

export enum FilterTypes {
  SELECT_SINGLE = 'select_single',
  SELECT_MULTIPLE = 'select_multiple',
  DATE_PICKER = 'date_picker',
  DATERANGE_PICKER = 'daterange_picker',
  SLIDER = 'slider',
  SEARCH = 'search'
}

export interface IFilterOption {
  id: string;
  name: string;
  value: any;
  selected: boolean;
}

export class FiltersStore {
  request_filters: FilterItem[];
  quote_filters: FilterItem[];
}
